import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Card, Col, Dropdown, Image, List, Row, Skeleton, Tabs, TabsProps, Typography, Grid } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { IoIosArrowBack } from "react-icons/io";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import ArtWorkModel from "../add/model";
import { viewArtwork } from "../../../api/artwork";
import { DeletePopupModal } from "../../elements/delete-popup-model/components";
import { ConditionReportModal } from "./condition-report-modal";
import './style.scss';
import { ENVIRONMENT } from "../../../common/constants";


const ViewArtworks = (props: any) => {
    const { userId, userName, userEmail } = props;
    const { id: artID } = useParams();
    const { Text, Title } = Typography;
    const { useBreakpoint } = Grid;

    const [artWorkData, setArtWorkData] = useState<any>([]);
    const [versions, setVersion] = useState({ versionID: '', version: '', fileS3Path: '', fileName: "", date: '' });
    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [deleteModelOpen, setDeleteModelOpen] = useState(false);
    const [conditionReportModelOpen, setConditionReportModelOpen] = useState(false);
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
    const [conditionReportModalLoading, setConditionReportModalLoading] = useState(false);

    const screens = useBreakpoint();
    const isMobile = !screens.md;

    useEffect(() => {
        fetchById();
    }, []);

    const fetchById = async () => {
        setLoading(true);
        try {
            const postData = {
                artId: Number(artID),
                userId: userId
            };
            const { data, status } = await viewArtwork(postData);
            if (status === 'Success') {
                setArtWorkData(data);
            }
        } catch (error) {
            console.error('Error while listing art data', error);
        }
        finally {
            setLoading(false);
        }
    };

    const initialVersionArt =
        artWorkData?.ArtworkMedia?.length > 0
            ? artWorkData.ArtworkMedia[artWorkData.ArtworkMedia.length - 1]
            : null;
    const formattedDate = new Date(initialVersionArt?.date)?.toLocaleDateString();
    const versionsarray = artWorkData?.ArtworkMedia?.filter((val: any) => val?.version !== "Initial version");
    const InitialVersion = artWorkData?.ArtworkMedia?.find((val: any) => val?.version == "Initial version");

    const labels = [
        { label: 'Title', value: artWorkData?.title },
        { label: 'Artist Name', value: artWorkData?.artistName },
        { label: 'Version', value: initialVersionArt?.version, },
        { label: 'Date of Artwork', value: formattedDate }
    ];

    const Lists = () => {
        return <List
            split
            grid={{ column: 1, xl: 1, xxl: 1, lg: 1, gutter: [5, 5] }}
            style={{ paddingTop: 10, textAlign: 'start' }}
            itemLayout="vertical"
            size="small"
        >
            {labels?.map((value, index) => {
                return <List.Item style={{ padding: 0 }} key={index}>
                    <Title level={5}>{value?.label} : <Text type="secondary">{value?.value}</Text></Title>
                </List.Item>;
            })}
        </List>;
    };

    const EmptyComponent = (props: any) => {
        const { height } = props;
        return (
            <>
                <Card variant="borderless"
                    style={{ height: height ? height : '' }}
                    className="no-artwork-card">
                    <Row gutter={32} justify="center" align="middle">
                        <Col span={24}>
                            <Text type="secondary" style={{
                                fontSize: '24px',
                                lineHeight: '36px',
                                fontWeight: 700,
                                color: '#171A1FFF'
                            }}>
                                No Versions Found
                            </Text>
                        </Col>
                        <Col span={24}>
                            <Button
                                icon={<PlusOutlined />}
                                style={{
                                    fontSize: 14,
                                    fontWeight: 400,
                                    background: '#636AE8FF',
                                    borderRadius: '6px',
                                    color: '#FFFFFFFF',
                                    padding: '10px 20px',
                                    marginTop: 10
                                }}
                                onClick={() => setOpen(true)}
                            >
                                Upload Version
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </>
        );
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <p style={{ fontSize: 16, fontWeight: 600, color: "#2c35e0" }}> Versions</p>,
        }
    ];

    return (
        <>
            <div style={{
                borderRight: '1px solid rgba(186, 182, 182, 0.14)',
                borderLeft: '1px solid rgba(186, 182, 182, 0.14)',
                background: '#fff',
                padding: 5,
                paddingTop: 20
            }}
            >
                <Link to='/artwork' style={{ display: 'inline-flex', alignItems: "center", color: '#2c35e0' }} ><IoIosArrowBack /> Back</Link>
            </div>
            <Card
                styles={{ header: { border: 'none', minHeight: 35 }, body: { paddingTop: 0 } }}
                style={{ borderTop: 'none', borderBottom: 'none', height: '100vh', borderRadius: '0 0 10px 10px', paddingTop: '30px' }}
            >
                {loading ? <Skeleton.Button
                    style={{ height: "70vh", marginTop: "1.4%" }}
                    active={true}
                    size={'small'}
                    shape={"square"}
                    block={true}
                /> : <>
                    <Row gutter={[10, 10]}>
                        {/* Left Column - Image + Button */}
                        <Col xs={24} md={24} lg={10} xl={7}>
                            <p style={{ fontSize: 22, fontWeight: 600, textAlign: 'start' }}>View Artwork</p>
                            <Card
                                variant="borderless"
                                style={{ boxShadow: 'none', background: '#eeedf2a1', padding: 25 }}
                                cover={
                                    <div id="initial-image">
                                        <Image
                                            preview={{
                                                maskClassName: 'mask-border',
                                                src: `https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/${InitialVersion?.['fileS3Path']}`,
                                            }}
                                            width={'100%'}
                                            style={{ borderRadius: 10, background: '#2196f34f' }}
                                            height={'40vh'}
                                            src={`https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/resizedImages/initialImage/${InitialVersion?.['fileS3Path']}`}
                                        />
                                        {Lists()}
                                        <div
                                            style={{
                                                textAlign: 'end',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: 10,
                                            }}
                                        >
                                            <Button
                                                onClick={() => {
                                                    setConditionReportModelOpen(true);
                                                    setVersion({
                                                        versionID: artWorkData?.id,
                                                        version: 'Initial version',
                                                        fileS3Path: InitialVersion?.['fileS3Path'],
                                                        fileName: InitialVersion?.['fileName'],
                                                        date: artWorkData?.date,
                                                    });
                                                }}
                                                style={{
                                                    fontSize: 14,
                                                    fontWeight: 400,
                                                    background: '#636AE8FF',
                                                    borderRadius: '6px',
                                                    color: '#FFFFFFFF',
                                                    display: 'flex',
                                                    padding: '10px 20px',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                Condition Report
                                            </Button>
                                        </div>
                                    </div>
                                }
                                styles={{ body: { padding: 0 } }}
                            />
                        </Col>

                        {/* Right Column - Versions + Tabs */}
                        <Col xs={24} md={24} lg={14} xl={17}>
                            <Card
                                title={
                                    <Row
                                        gutter={[10, 10]}
                                        justify={isMobile ? 'start' : 'space-between'}
                                        align="middle"
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                        }}
                                    >
                                        <Col
                                            span={isMobile ? 24 : 'auto'}
                                            style={{
                                                width: isMobile ? '100%' : 'auto',
                                            }}
                                        >
                                            <Tabs
                                                tabBarStyle={{ color: '#2c35e0' }}
                                                defaultActiveKey="1"
                                                items={items}
                                                style={{
                                                    width: '100%',
                                                    marginLeft: 10,
                                                    marginRight: 10,
                                                }}
                                            />
                                        </Col>

                                        <Col
                                            span={isMobile ? 24 : 'auto'}
                                            style={{
                                                width: isMobile ? '100%' : 'auto',
                                                textAlign: isMobile ? 'right' : 'right',
                                            }}
                                        >
                                            <Button
                                                icon={<PlusOutlined />}
                                                style={{
                                                    fontSize: 14,
                                                    fontWeight: 400,
                                                    background: '#636AE8FF',
                                                    borderRadius: '6px',
                                                    color: '#FFFFFFFF',
                                                    display: 'inline-flex',
                                                    padding: '10px 20px',
                                                    justifyContent: 'center',
                                                    marginLeft: isMobile ? 0 : 20,
                                                    width: isMobile ? '100%' : 'auto',
                                                }}
                                                onClick={() => setOpen(true)}
                                            >
                                                Upload Version
                                            </Button>
                                        </Col>
                                    </Row>
                                }
                                styles={{
                                    header: { border: 'none', padding: 0 },
                                    body: { padding: 5 },
                                }}
                                variant="borderless"
                                style={{ boxShadow: 'none' }}
                            >
                                {versionsarray?.length ? (
                                    <Card className="versions-container-2" variant="borderless">
                                        <Row gutter={[20, 20]}>
                                            {versionsarray.map((value: any, i: number) => (
                                                <Col xs={24} sm={12} md={8} lg={8} xl={6} key={i}>
                                                    <Card
                                                        hoverable
                                                        cover={
                                                            <Image
                                                                id="version-image"
                                                                preview={{
                                                                    maskClassName: 'mask-border',
                                                                    src: `https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/${value?.fileS3Path}`,
                                                                }}
                                                                style={{ borderRadius: 10 }}
                                                                height={200}
                                                                width={'100%'}
                                                                src={`https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/resizedImages/versionImage/${value?.fileS3Path}`}
                                                            />
                                                        }
                                                    >
                                                        <Row
                                                            align="middle"
                                                            justify="space-between"
                                                            style={{ paddingTop: 10 }}
                                                            gutter={[10, 10]}
                                                        >
                                                            <Col>
                                                                <p style={{ color: '#0000009c' }}>{value?.version}</p>
                                                            </Col>
                                                            <Col>
                                                                <Dropdown
                                                                    menu={{
                                                                        items: [{ key: '2', label: 'Delete' }],
                                                                        onClick: ({ key }) => {
                                                                            if (key === '2') {
                                                                                setDeleteModelOpen(true);
                                                                                setVersion({
                                                                                    versionID: value?.id,
                                                                                    version: value.version,
                                                                                    fileS3Path: value?.fileS3Path,
                                                                                    fileName: value?.fileName,
                                                                                    date: value?.date,
                                                                                });
                                                                            }
                                                                        },
                                                                    }}
                                                                    trigger={['click']}
                                                                >
                                                                    <HiOutlineDotsHorizontal />
                                                                </Dropdown>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Card>
                                ) : (
                                    <Row align="middle">
                                        <Col span={24}>
                                            <EmptyComponent height={'50vh'} />
                                        </Col>
                                    </Row>
                                )}
                            </Card>
                        </Col>
                    </Row>

                </>
                }
            </Card>

            <ArtWorkModel
                render={fetchById}
                artId={Number(artID)}
                userId={userId}
                artWorkData={artWorkData}
                open={open}
                page={'view'}
                setOpen={setOpen}
            />

            <DeletePopupModal
                artId={Number(artID)}
                render={fetchById}
                id={versions.versionID}
                title={versions.version}
                open={deleteModelOpen}
                setOpen={setDeleteModelOpen}
                deleteBtnLoading={deleteBtnLoading}
                setDeleteBtnLoading={setDeleteBtnLoading}
                type={'ArtWorkVersion'}
                userId={userId}
            />

            <ConditionReportModal
                measurements={artWorkData}
                title={artWorkData?.title}
                id={artWorkData?.id}
                version={versions.version}
                artistName={artWorkData?.artistName}
                fileName={versions.fileName}
                date={versions?.date}
                userName={userName}
                userEmail={userEmail}
                userId={userId}
                open={conditionReportModelOpen}
                fileS3Path={versions.fileS3Path}
                setOpen={setConditionReportModelOpen}
                conditionReportModalLoading={conditionReportModalLoading}
                setConditionReportModalLoading={setConditionReportModalLoading}
            // socketRef={socketRef}
            />
        </>
    );
};

export default ViewArtworks;